var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1998 1.38519C14.6704 1.62037 14.1007 1.77876 13.5031 1.85027C14.1132 1.48454 14.5816 0.905698 14.8019 0.215984C14.2317 0.554842 13.5986 0.800107 12.9262 0.933058C12.3872 0.359016 11.6188 0 10.7697 0C9.13829 0 7.8155 1.32279 7.8155 2.9542C7.8155 3.18555 7.8419 3.41113 7.89229 3.6276C5.43678 3.50473 3.26012 2.32832 1.80294 0.540923C1.54855 0.977214 1.40312 1.48454 1.40312 2.02595C1.40312 3.05068 1.92389 3.95494 2.71728 4.48483C2.23251 4.46947 1.7775 4.33651 1.37864 4.11525V4.1522C1.37864 5.58395 2.39762 6.77763 3.74825 7.04977C3.50058 7.11697 3.23948 7.15345 2.97022 7.15345C2.77967 7.15345 2.5944 7.13472 2.41394 7.10017C2.78975 8.27369 3.8812 9.12804 5.17375 9.15203C4.16294 9.94398 2.8891 10.4167 1.50488 10.4167C1.26585 10.4167 1.03067 10.4028 0.799805 10.375C2.10724 11.213 3.65993 11.7026 5.3283 11.7026C10.762 11.7026 13.7335 7.20096 13.7335 3.29738C13.7335 3.16923 13.7311 3.04156 13.7249 2.91533C14.3027 2.49776 14.8038 1.97747 15.1998 1.38519Z",
    fill: "#313945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterMin);
export default __webpack_public_path__ + "static/media/twitterMin.64088985cf1de7ebdf80f6b0e7465733.svg";
export { ForwardRef as ReactComponent };